"use client";

import { useCallback } from "react";
import classes from "./BackToTop.module.scss";
import ArrowWithTail from "@/assets/icons/ArrowWithTail";

const BackToTop = () => {
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <p className={classes["back-to-top"]} onClick={scrollToTop}>
      Back to Top
      <ArrowWithTail color={"white"} rotation={-90} />
    </p>
  );
};

export default BackToTop;
